import { methodSteps } from '@/mocks/home';

export default function MethodSteps() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="text-[11px] tracking-[0.3em] text-secondary-700 mb-3">逐帧确认</div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            四步走完一遍，再看结论
          </h2>
          <p className="text-sm md:text-base leading-relaxed text-foreground-600">
            不追求快。把每一步留出空白，线索才有机会自己浮上来。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {methodSteps.map((step, index) => (
            <div key={step.no} className="relative pt-6 border-t border-background-200">
              <span className="absolute -top-[7px] left-0 w-3.5 h-3.5 rounded-full bg-accent-500"></span>
              <div className="font-heading text-3xl font-black text-primary-500 mb-4">{step.no}</div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">{step.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              {index < methodSteps.length - 1 && (
                <span className="hidden lg:flex absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-5 h-5 items-center justify-center text-background-300">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}